// src/downloadWithAuth.js
import { getToken } from "./api";

export async function downloadFileWithAuth(fileId, filename) {
  const token = getToken();
  if (!token) {
    alert("Not authenticated");
    return;
  }
  try {
    const res = await fetch(`/api/download_file/${fileId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || err.msg || "Download failed");
    }
    const blob = await res.blob();
    // Try to get filename from Content-Disposition header
    let downloadName = filename;
    const cd = res.headers.get("Content-Disposition");
    if (cd) {
      const match = cd.match(/filename="?([^"]+)"?/);
      if (match) downloadName = match[1];
    }
    // Create a link and click it
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = downloadName || "file";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (e) {
    alert(e.message || "Download failed");
  }
}
